export default __webpack_public_path__ + "search.svg";